const { optionLabel, } = require('../lib/consolidationAccountItems');
const { isEmpty, } = require('lodash');
const { composeChangeFieldNames, composeChangeFields, } = require('./changeField');

const { entries } = Object;

const fixedChangeFieldLabels = {
  issue: '新規発行',
  redemption: '償還',
  transfer: '振替',
  other: 'その他',
};

const changeFieldNames = (customChangeFields = [], savedOrder, hiddenKeys = []) => composeChangeFieldNames(fixedChangeFieldLabels, customChangeFields, savedOrder, hiddenKeys);

const planFields = () => {
  return {
    year1: {
      label: '1年以内',
      type: 'float',
    },
    year2: {
      label: '1年超 2年以内',
      type: 'float',
    },
    year3: {
      label: '2年超 3年以内',
      type: 'float',
    },
    year4: {
      label: '3年超 4年以内',
      type: 'float',
    },
    year5: {
      label: '4年超 5年以内',
      type: 'float',
    },
    year6: {
      label: '5年超',
      type: 'float',
    },
  };
};

const fields = ({ accountItems = [], otherItems, customChangeFields = [], savedOrder, hiddenKeys = [], } = {}) => {
  const unique = (v, s) => otherItems?.every(o => ['accountItemId'].some(_ => o[_] !== s[_]));
  return {
    accountItemId: {
      label: '個別勘定科目',
      type: 'select',
      options: accountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
      validations: {
        required: v => v != null,
        unique,
      },
    },
    opening: {
      label: '期首',
      type: 'float',
      validations: {
        required: v => v != null,
      },
    },
    ...composeChangeFields(fixedChangeFieldLabels, customChangeFields, savedOrder, hiddenKeys),
  };
};

exports.fields = fields;
exports.changeFieldNames = changeFieldNames;
exports.planFields = planFields;
exports.fixedChangeFieldLabels = fixedChangeFieldLabels;
